import { render, staticRenderFns } from "./checkRate.vue?vue&type=template&id=fa56b11c&scoped=true"
import script from "./checkRate.vue?vue&type=script&lang=js"
export * from "./checkRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa56b11c",
  null
  
)

export default component.exports